/**
 * Sources accepted by the Cash Qore createPurchaseOrderAdjustment endpoint.
 * The API upper-cases the value before comparing, so case here is not significant.
 */
export const purchaseOrderAdjustmentSource = Object.freeze({
  INTERNAL: 'internal',
  EXTERNAL: 'external',
});
